import { os } from '@utils/device-utils';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useEffect, useMemo, useState } from 'react';
import styles from './styles.scss';



const PlatformSection: FC = () => {
	const { width } = useResizeObserver();
	const { transData, list } = useTranslation('oneOnOne.platform')
	const listRender = useMemo(() => {
		if (!Array.isArray(list)) return []
		return list.map((item, index) => {
			return (
				<div className={classnames(styles['ac-platform-item'], styles[`ac-platform-item-${item.id}`])} key={index}>
					{width < 768 ?
						<div className={styles['ac-platform-item-content']} >
							<img src={item.pImg} alt="" />
							<p>{item.title}</p>
						</div>
						:
						<div className={styles['ac-platform-item-content']} style={{ backgroundImage: `url(${item.img})` }}>
							<p>{item.title}</p>
						</div>}

				</div>)
		})
	}, [list])

	return (
		<section className={styles['ac-platform']}>
			<div className={styles['ac-platform-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }}></div>
				<div className={styles['platform-background-1']}>
					{width < 768 &&
						<img src={transData.padImg} alt="" />}
					{width > 768 && width < 1192 && <img src={transData.pcImg} alt="" />}
					{width >= 1192 && <img src={transData.pcImg} alt="" />}
				</div>
				<div className={styles['platform-background-2']}>
					<img src="https://web-data.zmlearn.com/image/cVmqgtav9rTRjPYUUeZgtq/img_p2_pic1%402x.png" alt="" />
				</div>
				<div className={styles['platform-background-3']}>
				</div>
				<div className={styles['ac-platform-list']}>
					{listRender}
				</div>
			</div>
		</section>
	);
}

export default PlatformSection
